module.exports = __webpack_public_path__ + "media/images/svg/jumping-kids-bd0654d3f73b3a366cf9e5b69cdc8970.svg";